import Phaser from "phaser";
import { TEX_PIXEL } from "../assets/primitives";
import { DisplayPool, isPhaserDestroyed } from "./DisplayPool";

export type FxSpritePool = DisplayPool<Phaser.GameObjects.Sprite>;
export type FxTextPool = DisplayPool<Phaser.GameObjects.Text>;

export function parkSprite(scene: Phaser.Scene, sprite: Phaser.GameObjects.Sprite): void {
  if (isPhaserDestroyed(sprite) || !sprite.anims) {
    return;
  }
  scene.tweens.killTweensOf(sprite);
  sprite.off(Phaser.Animations.Events.ANIMATION_COMPLETE);
  sprite.anims.stop();
  sprite.clearTint();
  sprite.setAlpha(1);
  sprite.setScale(1);
  sprite.setAngle(0);
  sprite.setRotation(0);
  sprite.setOrigin(0.5, 0.5);
  sprite.setFlipX(false);
  sprite.setFlipY(false);
}

export function parkText(scene: Phaser.Scene, text: Phaser.GameObjects.Text): void {
  if (isPhaserDestroyed(text)) {
    return;
  }
  scene.tweens.killTweensOf(text);
  text.setAlpha(1);
  text.setScale(1);
  text.setAngle(0);
}

export function createFxSpritePool(scene: Phaser.Scene, prewarm = 16): FxSpritePool {
  return new DisplayPool(
    () => scene.add.sprite(0, 0, TEX_PIXEL),
    (sprite) => parkSprite(scene, sprite),
    prewarm,
  );
}

export function createFxTextPool(scene: Phaser.Scene, prewarm = 6): FxTextPool {
  return new DisplayPool(
    () => {
      const text = scene.add.text(0, 0, "", {
        fontFamily: "Fredoka, Nunito, sans-serif",
        fontSize: "28px",
        color: "#f3e6c8",
        stroke: "#2a1a10",
        strokeThickness: 5,
      });
      text.setOrigin(0.5).setDepth(2100);
      return text;
    },
    (text) => parkText(scene, text),
    prewarm,
  );
}

export function resetFxSprite(sprite: Phaser.GameObjects.Sprite, key: string, frame = 0): void {
  sprite.setTexture(key, frame);
  sprite.clearTint();
  sprite.setAlpha(1);
  sprite.setScale(1);
  sprite.setAngle(0);
  sprite.setRotation(0);
  sprite.setOrigin(0.5, 0.5);
  sprite.setFlipX(false);
  sprite.setFlipY(false);
}
